import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'pp-vx/dist/components/text-input/text-input.css';
import React from 'react';
import clsx from 'clsx';

// Get either the error message or helper text or... nothing
var renderMessage = function (err, help, msgId) {
  return err && React.createElement("div", {
    className: "ppvx_text-input__error-text",
    id: msgId
  }, err) || help && React.createElement("div", {
    className: "ppvx_text-input__helper-text",
    id: msgId
  }, help) || null;
};

var textClass = 'ppvx_text-input';

var renderIcon = function (icon, side) {
  return icon ? React.cloneElement(icon, {
    className: clsx(icon.className, "".concat(textClass, "__icon--").concat(side))
  }) : null;
};

var TextInput = function (_ref) {
  var _clsx;

  var setFocus = _ref.setFocus,
      className = _ref.className,
      errorText = _ref.errorText,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? !!errorText : _ref$error,
      helperText = _ref.helperText,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      name = _ref.name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "text-input-".concat(name) : _ref$id,
      label = _ref.label,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? ' ' : _ref$placeholder,
      _ref$leftIcon = _ref.leftIcon,
      leftIcon = _ref$leftIcon === void 0 ? null : _ref$leftIcon,
      _ref$rightIcon = _ref.rightIcon,
      rightIcon = _ref$rightIcon === void 0 ? null : _ref$rightIcon,
      onChange = _ref.onChange,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["setFocus", "className", "errorText", "error", "helperText", "value", "defaultValue", "name", "id", "label", "multiline", "placeholder", "leftIcon", "rightIcon", "onChange", "children"]);

  var InputTag = multiline ? 'textarea' : 'input';
  var mainClasses = clsx(textClass, (_clsx = {
    'ppvx_field--error': error
  }, _defineProperty(_clsx, "".concat(textClass, "--nolabel"), !label || label === ''), _defineProperty(_clsx, "".concat(textClass, "--textarea"), multiline), _clsx), className);
  var msgId = "message_".concat(id);
  var valueProps = onChange ? {
    onChange: onChange,
    value: value
  } : {
    defaultValue: value
  };
  return React.createElement("div", {
    className: mainClasses
  }, renderIcon(leftIcon, 'left'), renderIcon(rightIcon, 'right'), React.createElement(InputTag, _extends({
    className: "".concat(textClass, "__control"),
    name: name,
    id: id,
    ref: function focusMe(elem) {
      if (setFocus && elem) {
        elem.focus();
      }
    },
    "aria-invalid": error,
    "aria-describedby": msgId,
    placeholder: placeholder
  }, valueProps, rest)), React.createElement("label", {
    htmlFor: id,
    className: "".concat(textClass, "__label")
  }, label), renderMessage(errorText, helperText, msgId));
};

export { TextInput };
